<template>
  <div ref="layout" class="page-form page-base">
    <h3 class="title">经销商销售发票</h3>

    <div class="form-container">
      <div class="tools">
        <form-button @click="$router.go(-1)">返回</form-button>
      </div>
      <el-form ref="form" inline size="mini" label-width="100px" disabled :model="conditions">
        <common-title title="基本信息" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="单据号">
              <el-input
                v-model="conditions.invupl_id"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="invoice" label="发票号码">
              <el-input
                v-model="conditions.invoice"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="inv_date" label="开票日期">
              <el-date-picker
                v-model="conditions.inv_date"
                type="date"
                value-format="yyyyMMdd"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="发票类型">
              <el-select
                v-model="conditions.inv_type"
              >
                <el-option
                  v-for="item in selectDataOptions['A0032']"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="customername" label="订单客户">
              <el-input v-model="conditions.customername" />
            </el-form-item>
          </el-col>
        </el-row>
        <common-title title="状态" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="销售方">
              <el-input
                v-model="conditions.sellername"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="单据状态">
              <el-select
                v-model="conditions.status"
              >
                <el-option
                  v-for="item in selectDataOptions['A0055']"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="上传日期">
              <el-date-picker
                v-model="conditions.upl_date"
                type="date"
                value-format="yyyyMMdd"
                format="yyyy-MM-dd"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="table-container">
      <TableCommon
        title="基础信息"
        :custome-config="() => vxeShowCustom('xTable')"
      >
        <vxe-grid
          ref="xTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="240"
          max-height="500"
          align="center"
          size="mini"
          :empty-render="{name: 'NotData'}"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.columns"
          :data="gridOptions.data"
        />
      </TableCommon>

      <TableCommon title="附件" :custome-config="() => vxeShowCustom('fileTable')">
        <vxe-grid
          ref="fileTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="240"
          max-height="500"
          align="center"
          size="mini"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptionsFile.columns"
          :data="gridOptionsFile.data"
        >
          <template #filename="{row}">
            <span class="blue" @click="downLoadFile(row)">{{
              row.filename
            }}</span>
          </template>
        </vxe-grid>
      </TableCommon>
    </div>
  </div>
</template>
<script>
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import { mapGetters } from 'vuex'
import { sapDownloadFile } from '@/utils/frontExport'
import { apiUploadInvoiceDetail } from '@/api/sap/dealer'

export default {
  name: 'InvoiceUpload',
  data() {
    return {
      conditions: {
        invupl_id: '',
        sellername: '',
        status: '新建',
        upl_date: '',
        invoice: '',
        inv_date: '',
        inv_type: '',
        customername: '',
        customer: '',
        seller: ''
      },
      selectDataOptions: {},
      gridOptions: {
        columns: [
          {
            field: 'product_id',
            title: '产品编号'
          },
          {
            field: 'product_text',
            title: '产品名称'
          },
          {
            field: 'quantity',
            title: '数量（瓶）'
          },
          {
            field: 'price',
            title: '含税单价（元/瓶）'
          },
          {
            field: 'amount',
            title: '含税总价'
          }
        ],
        data: []
      },
      loading: false,
      gridOptionsFile: {
        columns: [
          { field: 'filename', title: '附件名称', slots: { default: 'filename' }},
          { field: 'filetype', title: '附件类型' },
          { field: 'created_time', title: '上传时间' }
        ],
        data: []
      }
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  created() {
    this.getSelectDictDataOrigin('A0055')
    this.getSelectDictDataOrigin('A0032')
    const { id } = this.$route.query
    this.getDetail(id)
  },
  methods: {
    // 查询详情
    async getDetail(id) {
      const { data } = await apiUploadInvoiceDetail({ invupl_id: id })
      Object.assign(this.conditions, data.info)
      this.gridOptions.data = data.item
      if (data.info.filename) {
        this.gridOptionsFile.data.push({
          filename: data.info.filename,
          filedata: data.info.filedata,
          created_time: data.info.datum
        })
      }
    },
    // 文件下载
    downLoadFile(row) {
      sapDownloadFile(row.filedata, row.filename)
    },
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>

.blue {
    color: rgb(45, 146, 214);
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/views/dealer-manage/components/invoiceUploadCheck.vue